export class LocationViewModel {
  id: string;
  dateCreatedUtc: Date;
  dateDeletedUtc?: Date;
  locationId: string;
  locId: string;
  name: string;
  address: string;
  address2: string;
  city: string;
  state: string;
  country: string;
  zipcode: string;
  latitude: number;
  longitude: number;
  timezone?: string;
  isShipper: boolean;
  isConsignee: boolean;
  isBillTo: boolean;
  isOtherTypeOFLocation: boolean;
  contactName: string;
  contactPhone: string;
  contactEmail: string;
  fax: string;
  confidenceLevel: string;
  stateAbbreviation: string;
  countryAbbreviation: string;
  clientId: string;
  IsUserChosen: boolean;
  locationSpecificTraining?: string;
  productQualifications?: LocationProductQualification[];
}

export interface LocationProductQualification {
  id?: string;
  locationId?: string;
  productQualificationId: string;
  productQualificationName?: string;
  productQualificationAvatarFieldName?: string;
}
